module.exports = __webpack_public_path__ + "img/user.f9761c01.png";